import React, { useEffect, useState } from "react"
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Flex, Input, InputNumber, Select, Switch, Typography, message } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { lockersAction } from "src/store/Slices/Administrator/LockersSlice"
import { getClubs } from "src/store/Slices/DropDownSlice"

const emptyForm = {
  clubId: undefined,
  number: undefined,
  isBlocked: false,
  blockReason: "",
  price: undefined,
  localOn: "",
  localOff: "",
  localPulse: "",
  externalOn: "",
  externalOff: "",
  externalPulse: "",
}

const isYes = (value) => value === true || value === "Да"

const textOrNull = (value) => {
  const trimmed = typeof value === "string" ? value.trim() : value
  return trimmed === "" || trimmed == null ? null : trimmed
}

const AddEditLockerModal = ({
  visible,
  setVisible,
  lockerInfo,
  setPage,
  setPageSize,
  reload,
}) => {
  const dispatch = useDispatch()
  const clubs = useSelector((state) => state.DropDownSlice.clubs)
  const [form, setForm] = useState(emptyForm)

  const setField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }))
  }

  useEffect(() => {
    if (!visible.open) return
    dispatch(getClubs())
    if (visible.flag === "edit" && lockerInfo) {
      setForm({
        clubId: lockerInfo.clubId,
        number: lockerInfo.number,
        isBlocked: isYes(lockerInfo.isBlocked),
        blockReason: lockerInfo.blockReason || "",
        price: lockerInfo.price,
        localOn: lockerInfo.localOn || "",
        localOff: lockerInfo.localOff || "",
        localPulse: lockerInfo.localPulse || "",
        externalOn: lockerInfo.externalOn || "",
        externalOff: lockerInfo.externalOff || "",
        externalPulse: lockerInfo.externalPulse || "",
      })
    } else {
      setForm(emptyForm)
    }
  }, [visible, lockerInfo, dispatch])

  const close = () => setVisible({ open: false, flag: "" })

  const onClickSubmit = () => {
    if (!form.clubId) {
      message.error("Выберите клуб")
      return
    }
    if (form.number == null || form.number === "") {
      message.error("Укажите номер шкафчика")
      return
    }
    if (visible.flag === "edit" && !lockerInfo?.id) {
      message.error("Не выбран шкафчик")
      return
    }

    const body = {
      clubId: form.clubId,
      number: Number(form.number),
      lockId: null,
      isBlocked: !!form.isBlocked,
      blockReason: form.isBlocked ? textOrNull(form.blockReason) : null,
      price: form.price == null || form.price === "" ? null : Number(form.price),
      localOn: textOrNull(form.localOn),
      localOff: textOrNull(form.localOff),
      localPulse: textOrNull(form.localPulse),
      externalOn: textOrNull(form.externalOn),
      externalOff: textOrNull(form.externalOff),
      externalPulse: textOrNull(form.externalPulse),
    }
    if (visible.flag === "edit") body.id = lockerInfo.id

    dispatch(
      lockersAction({
        flag: visible.flag === "add" ? "put" : "post",
        value: body,
      }),
    ).then((result) => {
      if (result.payload?.response || result.payload?.data?.isSuccess === false) {
        return
      }
      reload()
      setPage(1)
      setPageSize(20)
      close()
    })
  }

  return (
    <CModal
      alignment='center'
      size='lg'
      visible={visible.open}
      onClose={close}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle>
          {visible.flag === "add" ? "Добавить шкафчик" : "Редактировать шкафчик"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <Flex vertical gap={16}>
          <div>
            <Typography.Title level={5}>Клуб</Typography.Title>
            <Select
              style={{ width: "100%" }}
              options={clubs?.data?.value}
              value={form.clubId}
              onChange={(value) => setField("clubId", value)}
              placeholder='Выбрать клуб'
            />
          </div>
          <Flex gap={16}>
            <div style={{ flex: 1 }}>
              <Typography.Title level={5}>Номер</Typography.Title>
              <InputNumber
                style={{ width: "100%" }}
                min={1}
                value={form.number}
                onChange={(value) => setField("number", value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Typography.Title level={5}>Цена</Typography.Title>
              <InputNumber
                style={{ width: "100%" }}
                min={0}
                value={form.price}
                onChange={(value) => setField("price", value)}
              />
            </div>
          </Flex>
          <Flex align='center' gap={12}>
            <Switch
              checked={form.isBlocked}
              onChange={(checked) => setField("isBlocked", checked)}
            />
            <span>Заблокирован</span>
          </Flex>
          <div>
            <Typography.Title level={5}>Причина блокировки</Typography.Title>
            <Input
              value={form.blockReason}
              disabled={!form.isBlocked}
              onChange={(e) => setField("blockReason", e.target.value)}
            />
          </div>

          <Typography.Title level={5}>Локальные токены</Typography.Title>
          <div>
            <div>Закрыть (ВКЛ)</div>
            <Input
              value={form.localOn}
              onChange={(e) => setField("localOn", e.target.value)}
            />
          </div>
          <div>
            <div>Открыть (ВЫКЛ)</div>
            <Input
              value={form.localOff}
              onChange={(e) => setField("localOff", e.target.value)}
            />
          </div>
          <div>
            <div>Открыть на 3 сек</div>
            <Input
              value={form.localPulse}
              onChange={(e) => setField("localPulse", e.target.value)}
            />
          </div>

          <Typography.Title level={5}>Сетевые токены</Typography.Title>
          <div>
            <div>Закрыть (ВКЛ)</div>
            <Input
              value={form.externalOn}
              onChange={(e) => setField("externalOn", e.target.value)}
            />
          </div>
          <div>
            <div>Открыть (ВЫКЛ)</div>
            <Input
              value={form.externalOff}
              onChange={(e) => setField("externalOff", e.target.value)}
            />
          </div>
          <div>
            <div>Открыть на 3 сек</div>
            <Input
              value={form.externalPulse}
              onChange={(e) => setField("externalPulse", e.target.value)}
            />
          </div>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton color='secondary' className='text-light' onClick={close}>
          Закрыть
        </CButton>
        <CButton className='text-light' onClick={onClickSubmit}>
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditLockerModal
